import styled from 'styled-components';
import { colors } from 'global/colors';

export const BenefitsList = styled.ul`
  padding-left: 20px;
`;

export const BenefitsListItem = styled.li`
  padding-bottom: 10px;
`;

export const TextLink = styled.p`
  cursor: pointer;
  color: ${colors.lightBlue4};
`;
